import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import { getMissionsByChauffeurAndCommande } from '../../api/commande';
import toast from 'react-hot-toast';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { FaCheck } from 'react-icons/fa';
import { useAuthenticatedFetch } from '../../hooks/useAuthenticatedFetch'
import { convertMinutesToHHMM, isValidTimeFormat } from '../../utils/formatters';
import zIndex from '@material-ui/core/styles/zIndex';
import { useTranslation } from 'react-i18next';




const headerStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    background: 'linear-gradient(135deg, #5BBCEA 0%, #2196F3 100%)',
    padding: '24px 32px',
    borderTopLeftRadius: '16px',
    borderTopRightRadius: '16px',
    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
};

const closeButtonStyle = {
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
    color: 'white',
    border: 'none',
    borderRadius: '50%',
    width: '36px',
    height: '36px',
    cursor: 'pointer',
    fontSize: '18px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    transition: 'all 0.2s ease',
};

const contentStyle = {
    padding: '1rem',
    background: '#FFFFFF',
    overflowY: 'auto',
    maxHeight: 'calc(85vh - 80px)',
    fontFamily: 'Montserrat',
};

const sectionStyle = {
    padding: '15px',
    marginBottom: '24px',
    backgroundColor: '#F8FAFC',
    borderRadius: '12px',
    border: '1px solid #E2E8F0',
};

const title = {
    color: '#2196F3',
    fontSize: '18px',
    fontWeight: 600,
    marginBottom: '16px',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
};

const detailsTitle = {
    color: '#334155',
    fontSize: '14px',
    fontWeight: 500,
    marginBottom: '8px',
};

const detailsSpan = {
    color: '#64748B',
    fontSize: '14px',
    fontWeight: 400,
    wordBreak: 'break-word',
    overflowWrap: 'break-word',
    whiteSpace: 'normal',
};

const priceTag = {
    padding: '12px 24px',
    background: 'linear-gradient(135deg, #5BBCEA 0%, #2196F3 100%)',
    color: 'white',
    borderRadius: '8px',
    fontSize: '16px',
    fontWeight: 600,
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    boxShadow: '0 2px 10px rgba(33, 150, 243, 0.2)',
};

const listItem = {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '8px 0',
    color: '#64748B',
};

const icon = {
    color: '#10B981',
    fontSize: '16px',
};

const DetailCommandeModal = ({ isOpen, onClose, commandeId }) => {
    const [chargementEnCours, setChargementEnCours] = useState(false);
    const token = useSelector((state) => state.auth.token);
    const user = useSelector((state) => state.auth.user);
    const [commande, setCommande] = useState(null);
    const { fetchResource } = useAuthenticatedFetch();
    const [fileUrls, setFileUrls] = useState({});
    const { t } = useTranslation();
    const [isMobile, setIsMobile] = useState(() => window.innerWidth < 768);

    useEffect(() => {
        const checkScreen = () => {
            const width = window.innerWidth;

            setIsMobile(width < 768);

        };
        checkScreen();
        window.addEventListener('resize', checkScreen);

        return () => window.removeEventListener('resize', checkScreen);
    }, []);

    // Charger toutes les URLs des fichiers
    const loadAllFiles = async (commandeData) => {
        const urls = {}

        // Fichiers de la commande
        if (commandeData?.files) {
            for (const file of commandeData.files) {
                try {
                    const url = await fetchResource(file.path, token)
                    urls[file.path] = url
                } catch (error) {
                    console.error('Erreur chargement fichier commande:', error)
                }
            }
        }

        // Fichiers des missions
        if (commandeData?.missions) {
            for (const mission of commandeData.missions) {
                // Fichiers de mission
                if (mission.files) {
                    for (const file of mission.files) {
                        try {
                            const url = await fetchResource(file.path, token)
                            urls[file.path] = url
                        } catch (error) {
                            console.error('Erreur chargement fichier mission:', error)
                        }
                    }
                }

                // Lettres de route
                if (mission?.lettres_route) {
                    for (const letter of mission?.lettres_route) {
                        try {
                            const url = await fetchResource(letter.path, token)
                            urls[letter.path] = url
                        } catch (error) {
                            console.error('Erreur chargement lettre de route:', error)
                        }
                    }
                }
            }
        }

        setFileUrls((prev) => ({ ...prev, ...urls }))
    }


    const fetchCommande = async (commandeId) => {
        setChargementEnCours(true);
        try {
            const res = await getMissionsByChauffeurAndCommande(commandeId, user?._id, token);
            console.log(res);
            setCommande(res);
        } catch (error) {
            toast.error(t("transfer_request_err"), {
                style: {
                    fontFamily: 'Montserrat',
                },
            });
        } finally {
            setChargementEnCours(false);
        }
    };



    const getForfaitDetails = (forfait) => {
        switch (forfait.type) {
            case 'kilometrage':
            case 'kilometrage_etage':
                return (
                    <>
                        <strong >{t("mileage")} :{' '}</strong>
                        <span style={{ color: '#FF5A5F' }}>{forfait.details?.kilometrage ?? 'N/A'} km</span>
                        <strong style={{ marginLeft: "1rem" }}>{t("floors")} :{' '}</strong>
                        <span style={{ color: '#FF5A5F' }}>{forfait.details?.etages ?? '0'}</span>
                        <strong style={{ marginLeft: "1rem" }}>{t("price")} :{' '}</strong>
                        <span style={{ color: '#FF5A5F' }}>{forfait.prix}€ HT</span>
                    </>
                );
            case 'heure':
            case 'heure_etage':
                return (
                    <>
                        <strong >{t("hours")} :{' '}</strong>
                        <span style={{ color: '#FF5A5F' }}>{forfait.details?.heures ?? 'N/A'}</span>
                        <strong style={{ marginLeft: "1rem" }}>{t("floors")} :{' '}</strong>
                        <span style={{ color: '#FF5A5F' }}>{forfait.details?.etages ?? '0'}</span>
                        <strong style={{ marginLeft: "1rem" }}>{t("price")} :{' '}</strong>
                        <span style={{ color: '#FF5A5F' }}>{forfait.prix}€ HT</span>

                    </>
                );
            case 'etage':
                return (
                    <>
                        <strong >{t("floors")} : {' '}</strong>
                        <span style={{ color: '#FF5A5F' }}>{forfait.details?.etages ?? '0'}</span>
                        <strong style={{ marginLeft: "1rem" }}>{t("price")} :{' '}</strong>
                        <span style={{ color: '#FF5A5F' }}>{forfait.prix}€ HT</span>

                    </>
                );
            case 'forfait_gratuit':
                return (
                    <>
                        <strong>{t("hours")} :{' '}</strong>
                        <span style={{ color: '#FF5A5F' }}>{forfait.details?.heures ?? 'N/A'}</span>
                        <strong style={{ marginLeft: "1rem" }}>{t("price")} :{' '}</strong>
                        <span style={{ color: '#FF5A5F' }}>{forfait.prix}€ HT</span>

                    </>
                );
            default:
                return <span>{t("no_details")}</span>;
        }
    };

    const getForfaitLabel = (type) => {
        switch (type) {
            case 'kilometrage': return t("mileage");
            case 'kilometrage_etage': return t("mileage&floors");
            case 'heure': return t("extra_hours");
            case 'heure_etage': return t("hours&floors");
            case 'etage': return t("floors");
            case 'forfait_gratuit': return t("free_package");
            default: return type;
        }
    };

    const renderStatutMission = (statut) => {
        switch (statut) {
            case "init": return t("not_started");
            case "en-cours": return t("in_progress");
            case "terminer": return t("completed");
            case "annuler": return t("cancelled");
            default: return t("unknown");
        }
    };
    const renderVehicleOption = (option) => {
        switch (option) {
            case "Frigorifique":
                return t("refrigerated");
            case "Bachée":
                return t("tarped");
            case "Hayon":
                return t("liftgate");
            default:
                return option;
        }
    };
    const renderHeavyVehicleType = (type) => {
        switch (type) {
            case "Tracteur+semi":
                return t("tractor_semi");
            case "Semi":
                return t("semi");
            case "Tracteur":
                return t("tractor");
            default:
                return type;
        }
    };
    const renderLightVehicleType = (type) => {
        switch (type) {
            case "Break":
                return t("break");
            case "Fourgon":
                return t("fourgon");
            case "Camion":
                return t("camion");
            default:
                return type;
        }
    };
    const renderHandlingEq = (eq) => {
        switch (eq) {
            case "Diable":
                return t("handling_eq1");
            case "Transpalette manuel":
                return t("handling_eq2");
            case "Transpalette électrique":
                return t("handling_eq3");
            case "Sangle":
                return t("handling_eq4");
            default:
                return eq;
        }
    };
    const renderPPEq = (eq) => {
        switch (eq) {
            case "Casque":
                return t("ppe_eq1");
            case "Gants":
                return t("ppe_eq2");
            case "Masque":
                return t("ppe_eq3");
            case "Lunettes":
                return t("ppe_eq4");
            case "Chaussure de sécurité":
                return t("ppe_eq5");
            case "Gilet de visibilité":
                return t("ppe_eq6");
            default:
                return eq;
        }
    };






    const renderMissionDetails = (mission, index) => (
        <div key={index} style={sectionStyle}>
            <span style={title}>{t("mission_details")} N° {index + 1}</span>
            <p style={detailsTitle}>{t("start_date")} : <span style={detailsSpan}>{mission?.date_debut} {mission?.heure_debut}</span></p>
            <p style={detailsTitle}>{t("end_date")} : <span style={detailsSpan}>{mission?.date_fin} {mission?.heure_fin}</span></p>
            {mission?.date_debut_reel &&
                <p style={detailsTitle}>{t("actual_start_date")} : <span style={detailsSpan}>{moment(mission?.date_debut_reel).format("DD/MM/YYYY HH:mm")} </span></p>
            }
            {mission?.date_fin_reel &&
                <p style={detailsTitle}>{t("actual_end_date")} : <span style={detailsSpan}>{moment(mission?.date_fin_reel).format("DD/MM/YYYY HH:mm")} </span></p>
            }
            <p style={detailsTitle}>{t("start_address")} : <span style={detailsSpan}>{mission?.adresse_debut?.label}</span></p>
            <p style={detailsTitle}>{t("end_address")} : <span style={detailsSpan}>{mission?.adresse_fin?.label}</span></p>
            <p style={detailsTitle}>{t("mission_status")} : <span style={detailsSpan}>{renderStatutMission(mission?.statut)}</span></p>
            <p style={detailsTitle}>{t("km_number")} : <span style={detailsSpan}>{mission?.kilometrage} KM</span></p>
            <p style={detailsTitle}>{t("load_type")} : <span style={detailsSpan}>{mission?.nature_chargement === "vrac" ? t("bulk") : t("pallet")}</span></p>

            {mission?.nature_chargement === "vrac" ? (
                <p style={detailsTitle}>{t("number_of_dimensions")} : <span style={detailsSpan}>{mission?.nombre_dimension}</span></p>
            ) : (
                <>
                    <p style={detailsTitle}>{t("number_of_pallets")} : <span style={detailsSpan}>{mission?.nombre_palettes}</span></p>
                    <p style={detailsTitle}>{t("type_of_pallet")} : <span style={detailsSpan}>{mission?.nature_palettes}</span></p>
                </>
            )}

            <p style={detailsTitle}>{t("delivery_location")} : <span style={detailsSpan}>{mission?.livraison === "Domicile/Batiment/Maison" ? t("pickup_point2") : t("pickup_point1")}</span></p>

            {mission?.livraison === "Domicile/Batiment/Maison" && (
                <>
                    <p style={detailsTitle}>
                        {t("number_of_floors")} : <span style={detailsSpan}>
                            {mission?.etage === 'RDC' ? t("ground_floor") : mission?.etage}
                        </span>
                    </p>
                    <p style={detailsTitle}>{t("elevator")} : <span style={detailsSpan}>{mission?.ascenseur ? t("yes") : t("no")}</span></p>
                    <p style={detailsTitle}>{t("stairs")} : <span style={detailsSpan}>{mission?.escalier ? t("yes") : t("no")}</span></p>
                </>
            )}

            <p style={detailsTitle}>{t("transport_type")} :
                <span style={detailsSpan}>
                    {mission?.type_transport === "Poids lourds" ? t("vehicle_type1") : t("vehicle_type2")} {mission?.type_transport === "Poids lourds" ? renderHeavyVehicleType(mission?.vehicule_poids_lourds) : renderLightVehicleType(mission?.type_transport_details)}
                </span>
            </p>

            {mission?.type_transport === "Poids lourds" ? (
                <p style={detailsTitle}>{t("heavy_truck_options")} : <span style={detailsSpan}>{mission?.options_poids_lourds
                    ?.map(option => renderVehicleOption(option))
                    .join(", ")}</span></p>
            ) : (
                <p style={detailsTitle}>{t("light_vehicle_options")} : <span style={detailsSpan}>{mission?.options_vehicule_leger
                    ?.map(option => renderVehicleOption(option))
                    .join(", ")}</span></p>
            )}

            <p style={detailsTitle}>{t("driver_handling")}  : <span style={detailsSpan}>{mission?.manutention_chauffeur ? t("yes") : t("no")}</span></p>
            <p style={detailsTitle}>{t("number_of_loaders")} : <span style={detailsSpan}>{mission?.nombre_rippeur || 0}</span></p>
            <p style={detailsTitle}>{t("hazardous_materials")} : <span style={detailsSpan}>{mission?.danger ? t("yes") : t("no")}</span></p>
            <p style={detailsTitle}>{t("useful_note")} : <span style={detailsSpan}>{mission?.notes}</span></p>

            <div style={sectionStyle}>
                <span style={title}>{t("stop_point")}</span>
                {mission?.points_passage?.length > 0 ? (
                    mission.points_passage.map((point, idx) => (
                        <div key={idx} style={{ ...(idx !== 0 && { borderTop: '1px solid #D9D9D9A8', marginTop: '16px', paddingTop: '16px' }) }}>
                            <p style={detailsTitle}>{t("address")} : <span style={detailsSpan}>{point.adresse.label}</span></p>
                            <div style={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', gap: isMobile ? '10px' : '24px' }}>
                                <p style={detailsTitle}>Distance : <span style={detailsSpan}>{point.distance}</span></p>
                                <p style={detailsTitle}>{t("hours")} : <span style={detailsSpan}>{point?.heure && isValidTimeFormat(point.heure) ? point.heure : convertMinutesToHHMM(point?.heure || 0)}</span></p>
                            </div>
                            {idx !== 0 && (
                                <>
                                    {point?.nom_destinataire && (
                                        <p style={detailsTitle}>{t("recipient_first_and_last_name")} : <span style={detailsSpan}>{point.nom_destinataire}{' '}{point.prénom_destinataire}</span></p>
                                    )}

                                    {point?.adresse_destinataire && (
                                        <p style={detailsTitle}>
                                            {t("recipient_address")} : <span style={detailsSpan}>{point.adresse_destinataire}</span>
                                            {point?.téléphone_destinataire && (
                                                <span style={detailsSpan}>, {t("contact_us_formulair_item2")}: {point.téléphone_destinataire}</span>
                                            )}
                                        </p>
                                    )}

                                    {point?.email_destinateur && (
                                        <p style={detailsTitle}>{t("email_destinataire")} : <span style={detailsSpan}>{point.email_destinateur}</span></p>
                                    )}

                                    <div style={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', gap: '24px', marginTop: '8px' }}>
                                        <p style={detailsTitle}>{t("signed")} : <span style={detailsSpan}>{point?.signé ? t("yes") : t("no")}</span></p>
                                        <p style={detailsTitle}>{t("reported")} : <span style={detailsSpan}>{point?.signaler ? t("yes") : t("no")}</span></p>
                                        <p style={detailsTitle}>{t("active")} : <span style={detailsSpan}>{point?.active ? t("yes") : t("no")}</span></p>
                                    </div>
                                </>
                            )

                            }
                        </div>
                    ))
                ) : (
                    <span style={detailsSpan}>{t("no_stop_points")}</span>
                )}
            </div>

            <div style={sectionStyle}>
                <span style={title}>{t("additional_packages")}</span>
                {mission?.forfaits?.length > 0 ? (
                    mission.forfaits.map((forfait, idx) => (
                        <div key={idx} style={{ ...(idx !== 0 && { borderTop: '1px solid #D9D9D9A8', marginTop: '16px', paddingTop: '16px' }) }}>
                            <p style={detailsTitle}>Type : <span style={detailsSpan}>{getForfaitLabel(forfait.type)}</span></p>
                            <p style={detailsTitle}> <span style={detailsSpan}>{getForfaitDetails(forfait)}</span>
                            </p>
                        </div>
                    ))
                ) : (
                    <span style={detailsSpan}>{t("no_packages")}</span>
                )}
            </div>

            <p style={detailsTitle}>{t("associated_documents")}: {' '}
                {mission?.files?.length > 0 ? (
                    mission.files.map((file, index) => (
                        <>
                            <span key={index} style={detailsTitle}>
                                <a
                                    href={fileUrls[file.path]}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ color: '#2196F3', textDecoration: 'none' }}

                                >
                                    {file.name}
                                </a>
                            </span>
                            <span style={{ marginLeft: '.5rem' }} />
                        </>
                    ))
                ) : (
                    <span style={detailsSpan}>{t("no_associated_documents")}</span>
                )}
            </p>
            <p style={detailsTitle}>
                {t("waybills")}: {' '}
                {mission.lettres_route?.length > 0 ? (
                    mission.lettres_route?.map((letter) => (
                        <div key={letter._id} style={{ marginTop: '8px' }}>
                            <a
                                href={fileUrls[letter.path]}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                    color: '#2196F3', textDecoration: 'none', overflow: 'hidden',
                                    whiteSpace: 'normal',        // allow wrapping
                                    overflowWrap: 'anywhere',
                                }}

                            >
                                {letter.name}
                            </a>
                        </div>
                    ))
                ) : (
                    <span style={detailsSpan}>{t("no_waybills_available")}</span>
                )}
            </p>


        </div>
    );

    const renderCoursesDetails = (courses) => {
        console.log("courses", courses)
        if (!courses || courses.length === 0) {
            return <p style={detailsSpan}>{t("no_trips_available")}</p>;
        }

        return (
            <div>
                {/* Première course (plus détaillée) */}
                <div style={{ marginBottom: '1.5rem' }}>
                    <span style={title}>{t("first_trip_details")}</span>

                    <p style={detailsTitle}>
                        {t("start_date")} : <span style={detailsSpan}>{courses[0]?.date_debut} {courses[0]?.heure_debut}</span>
                    </p>
                    <p style={detailsTitle}>
                        {t("start_address")} : <span style={detailsSpan}>{courses[0]?.adresse_debut?.label}</span>
                    </p>

                    <p style={detailsTitle}>
                        {t("end_date")} : <span style={detailsSpan}>{courses[0]?.date_fin} {courses[0]?.heure_fin}</span>
                    </p>
                    <p style={detailsTitle}>
                        {t("end_address")} : <span style={detailsSpan}>{courses[0]?.adresse_fin?.label}</span>
                    </p>

                    <p style={detailsTitle}>
                        {t("start_type")} : <span style={detailsSpan}>{courses[0]?.type_debut === "Déchargement" ? t("unloading") : t("loading")}</span>
                    </p>
                    <p style={detailsTitle}>
                        {t("start_notes")} : <span style={detailsSpan}>{courses[0]?.notes_debut || t("no_notes")}</span>
                    </p>

                    <p style={detailsTitle}>
                        {t("end_type")} : <span style={detailsSpan}>{courses[0]?.type_fin === "Déchargement" ? t("unloading") : t("loading")}</span>
                    </p>
                    <p style={detailsTitle}>
                        {t("end_notes")} : <span style={detailsSpan}>{courses[0]?.notes_fin || t("no_notes")}</span>
                    </p>
                </div>

                {/* Les autres courses */}
                {courses.slice(1).map((course, index) => (
                    <div key={index} style={{ marginBottom: '1rem' }}>
                        <span style={title}>{t("intermediate_trip")} N° {index + 2}</span>

                        <p style={detailsTitle}>
                            Date : <span style={detailsSpan}>{course?.date} {course?.heure}</span>
                        </p>
                        <p style={detailsTitle}>
                            {t("address")} : <span style={detailsSpan}>{course?.adresse?.label}</span>
                        </p>
                        <p style={detailsTitle}>
                            Type : <span style={detailsSpan}>{course?.type}</span>
                        </p>
                        <p style={detailsTitle}>
                            Notes : <span style={detailsSpan}>{course?.notes || t("no_notes")}</span>
                        </p>

                        <p style={detailsTitle}>
                            {t("associated_documents")} :{' '}
                            {course?.files?.length > 0 ? (
                                course.files.map((file, i) => (
                                    <span key={i} style={{ marginRight: '.5rem' }}>
                                        <a
                                            href={fileUrls[file.path]}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{ color: '#2196F3', textDecoration: 'none' }}
                                        >
                                            {file.name}
                                        </a>
                                    </span>
                                ))
                            ) : (
                                <span style={detailsSpan}>{t("no_associated_documents")}</span>
                            )}
                        </p>
                    </div>
                ))}
            </div>
        );
    };
    useEffect(() => {
        if (commandeId && isOpen) {
            fetchCommande(commandeId)
                .then((commandeData) => {
                    if (commandeData) {
                        loadAllFiles(commandeData)
                    }
                })
                .catch(() => { })
        }
    }, [commandeId, isOpen])
    const modalStyles = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            padding: '0',
            borderRadius: '16px',
            border: 'none',
            boxShadow: '0 8px 30px rgba(0, 0, 0, 0.12)',
            fontFamily: 'Montserrat, sans-serif',
            maxHeight: '85vh',
            overflow: 'hidden',
            width: isMobile ? "90%" : "60%",
            maxWidth: '1200px',
        },
        overlay: {
            backgroundColor: 'rgba(0, 0, 0, 0.75)',
            backdropFilter: 'blur(5px)',
            zIndex: 1000
        },
    };

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onClose}
            ariaHideApp={false}
            style={modalStyles}
        >
            <div style={headerStyle}>
                <h3 style={{ color: 'white', margin: 0, flex: 1, textAlign: 'center' }}>
                    {`${t("order_details")} N°${commande ? commande?.__id : ''}`}
                </h3>
                <button onClick={onClose} style={closeButtonStyle}>×</button>
            </div>

            {chargementEnCours ? (
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: 'white',
                    marginTop: "2rem",
                    marginBottom: "2rem"
                }} >
                    <div className='customLoader'></div>
                </div>
            ) : (
                <div style={contentStyle}>
                    <div style={{ ...sectionStyle, marginTop: 0 }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <span style={title}>{t("transport_details")}</span>

                        </div>

                        <p style={detailsTitle}>{t("transport_type")} :
                            <span style={detailsSpan}>
                                {commande?.type_commande === "mise-a-disposition" ? t("mise_à_disposition") : t("course_à_course")}
                            </span>
                        </p>
                        <p style={detailsTitle}>{t("timing_type")} :
                            <span style={detailsSpan}>
                                {commande?.temporisation === "immediat" ? t("immédiate") : t("planifiée")}
                            </span>
                        </p>

                    </div>

                    {commande?.type_commande === "mise-a-disposition" && commande?.missions?.length > 0 && (
                        commande.missions.map((mission, index) => renderMissionDetails(mission, index))
                    )}
                    {commande?.type_commande === "course-a-course" && commande?.courses?.length > 0 &&

                        (renderCoursesDetails(commande?.courses))

                    }

                    {commande?.type_commande === "mise-a-disposition" && <div style={sectionStyle}>
                        <span style={title}>{t("signatory_details")}</span>
                        <p style={detailsTitle}>{t("contact_us_formulair_item1")} :
                            <span style={detailsSpan}>
                                {commande?.nom_signataire} {commande?.prénom_signataire}
                            </span>
                        </p>
                        <p style={detailsTitle}>{t("contact_us_formulair_item2")} 1 :
                            <span style={detailsSpan}>
                                {commande?.téléphone1_signataire}
                            </span>
                        </p>
                        <p style={detailsTitle}>{t("contact_us_formulair_item2")} 2 :
                            <span style={detailsSpan}>
                                {commande?.téléphone2_signataire}
                            </span>
                        </p>
                        <p style={detailsTitle}>Email :
                            <span style={detailsSpan}>
                                {commande?.email_signataire}
                            </span>
                        </p>
                    </div>}
                    {commande?.type_commande === "course-a-course" &&
                        <div style={sectionStyle}>
                            <span style={title}>{t("transport_information")}</span>
                            <p style={detailsTitle}>{t("km_number")} : {' '}
                                <span style={detailsSpan}>{commande?.distance}KM</span>
                            </p>
                            <p style={detailsTitle}>{t("load_type")} : {' '}
                                <span style={detailsSpan}>{commande?.nature_chargement === "vrac" ? t("bulk") : t("pallet")}</span>
                            </p>
                            {commande?.nature_chargement === "vrac" ?
                                <p style={detailsTitle}>{t("number_of_dimensions")} : {' '}
                                    <span style={detailsSpan}>{commande?.nombre_dimension}</span>
                                </p>
                                :
                                <>
                                    <p style={detailsTitle}>{t("vehicle_detail6")} : {' '}
                                        <span style={detailsSpan}>{commande?.nombre_palettes}</span>
                                    </p>
                                    <p style={detailsTitle}>{t("type_of_pallet")} : <span style={detailsSpan}>{commande?.nature_palettes}</span></p>
                                </>
                            }
                            <p style={detailsTitle}>{t("delivery_location")} : {' '}
                                <span style={detailsSpan}>{commande?.livraison === "Domicile/Batiment/Maison" ? t("pickup_point2") : t("pickup_point1")}</span>
                            </p>
                            {commande?.livraison === "Domicile/Batiment/Maison" &&
                                <>
                                    <p style={detailsTitle}>
                                        {t("number_of_floors")} : <span style={detailsSpan}>
                                            {commande?.etage === 'RDC' ? t("ground_floor") : commande?.etage}
                                        </span>
                                    </p>
                                    <p style={detailsTitle}>{t("elevator")} : {' '}
                                        <span style={detailsSpan}>{commande?.ascenseur ? t("yes") : t("no")}</span>
                                    </p>
                                    <p style={detailsTitle}>{t("stairs")} : {' '}
                                        <span style={detailsSpan}>{commande?.escalier ? t("yes") : t("no")}</span>
                                    </p>

                                </>
                            }
                            <p style={detailsTitle}>{t("transport_type")} :{' '}
                                <span style={detailsSpan}>
                                    {commande?.type_transport === "Poids lourds" ? t("vehicle_type1") : t("vehicle_type2")}
                                </span>
                            </p>

                            <p style={detailsTitle}>{t("category")} :{' '}
                                <span style={detailsSpan}>
                                    {commande?.type_transport === "Poids lourds" ?

                                        (commande?.vehicule_poids_lourds === "Tracteur+semi" ? t("tractor_semi") :
                                            commande?.vehicule_poids_lourds === "Semi" ? t("semi") :
                                                commande?.vehicule_poids_lourds === "Tracteur" ? t("tractor") :
                                                    commande?.vehicule_poids_lourds
                                        ) :
                                        (commande?.type_transport_details === "Break" ? t("break") :
                                            commande?.type_transport_details === "Fourgon" ? t("fourgon") :
                                                commande?.type_transport_details === "Camion" ? t("camion") :
                                                    commande?.type_transport_details
                                        )
                                    }
                                </span>
                            </p>

                            {commande?.type_transport === "Poids lourds" ?
                                <p style={detailsTitle}>{t("heavy_truck_options")} : {' '}
                                    <span style={detailsSpan}>{commande?.options_poids_lourds.join(',')}</span>
                                </p>
                                :
                                <p style={detailsTitle}>{t("light_vehicle_options")} : {' '}
                                    <span style={detailsSpan}>{commande?.options_vehicule_leger.join(',')}</span>
                                </p>
                            }
                            <p style={detailsTitle}>{t("driver_handling")} : {' '}
                                <span style={detailsSpan}>{commande?.manutention_chauffeur ? t("yes") : t("no")}</span>
                            </p>
                            <p style={detailsTitle}>{t("number_of_loaders")}: {' '}
                                <span style={detailsSpan}>{commande?.nombre_rippeur ? commande?.nombre_rippeur : 0}</span>
                            </p>
                            <p style={detailsTitle}>{t("hazardous_materials")} : {' '}
                                <span style={detailsSpan}>{commande?.danger ? t("yes") : t("no")}</span>
                            </p>
                            <p style={detailsTitle}>Assurance :
                                <span style={detailsSpan}>{commande?.assurance ? t("yes") : t("no")}</span>
                            </p>
                            {commande?.assurance && (
                                <p style={detailsTitle}>{t("insurance_amount")} :
                                    <span style={detailsSpan}>{commande?.assurance_amount} €</span>
                                </p>
                            )}
                        </div>
                    }
                    <div style={sectionStyle}>
                        <span style={title}>{t("additional_equipment")}</span>
                        <div>
                            <p style={detailsTitle}>{t("handling_equipment")} :</p>
                            {commande?.manutention?.map((item, index) => (
                                <div style={listItem} key={index}>
                                    <FaCheck style={icon} />
                                    <span style={detailsSpan}>{renderHandlingEq(item)}</span>
                                </div>
                            ))}
                        </div>
                        <div style={{ marginTop: '16px' }}>
                            <p style={detailsTitle}>{t("ppe")} :</p>
                            {commande?.epi?.map((item, index) => (
                                <div style={listItem} key={index}>
                                    <FaCheck style={icon} />
                                    <span style={detailsSpan}>{renderPPEq(item)}</span>
                                </div>
                            ))}
                        </div>
                        {commande?.transpalette_électrique && (
                            <div style={listItem}>
                                <FaCheck style={icon} />
                                <span style={detailsSpan}>{t("handling_eq3")}</span>
                            </div>
                        )}
                    </div>

                    <div style={sectionStyle}>
                        <span style={title}>{t("additional_information")}</span>
                        <p style={detailsTitle}>{t("internal_refrence")} :
                            <span style={detailsSpan}>
                                {commande?.ref_client}
                            </span>
                        </p>
                        <p style={detailsTitle}>{t("associated_documents")} :
                            {commande?.files?.length > 0 ? (
                                commande.files.map((file, index) => (
                                    <>
                                        <span key={index} style={detailsTitle}>
                                            <a
                                                href={fileUrls[file.path]}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                style={{
                                                    color: '#2196F3', textDecoration: 'none', overflow: 'hidden',
                                                    whiteSpace: 'normal',        // allow wrapping
                                                    overflowWrap: 'anywhere',
                                                }}

                                            >
                                                {file.name}
                                            </a>
                                        </span>
                                        <span style={{ marginLeft: '.5rem' }} />
                                    </>
                                ))
                            ) : (
                                <span style={detailsSpan}>{t("no_associated_documents")}</span>
                            )}
                        </p>
                    </div>
                </div>
            )}
        </Modal>
    );
};

export default DetailCommandeModal;